import {TdoDropdownModel} from '../../../../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import {EnumValidValueItemModel} from '../../../../../models/enum/enum-valid-value-item.model';
import {TdoOrganizerFilterResultModel} from './tdo-organizer-filter-result.model';

export class TdoOrganizerFilterDataModel {
  doctorsDropdownData: TdoDropdownModel[];
  referringDoctorsDropdownData: TdoDropdownModel[];

  documentTagOptions: EnumValidValueItemModel[];

  filterModel: TdoOrganizerFilterResultModel;
  dateRangeDropDownData: TdoDropdownModel[];
}
